import * as Yup from "yup";
import { enums } from "../constants/enum";

const { CUSTOMER_TITLES, CUSTOMER_TYPES } = enums;

const customerCreateValidationSchema = Yup.object().shape({
  title: Yup.string()
    .uppercase()
    .oneOf(
      Object.values(CUSTOMER_TITLES),
      `Customer title must be one of ${Object.values(CUSTOMER_TITLES).join(
        ", "
      )}.`
    )
    .required("Customer title is required."),

  name: Yup.string()
    .trim()
    .min(1, "Customer name should have at least 1 characters.")
    .max(100, "Customer name should have at most 100 characters.")
    .required("Customer name is required."),

  dob: Yup.date()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .max(new Date(), "Date of birth must be in the past.")
    .nullable()
    .notRequired()
    .typeError("Date of birth must be a valid date."),

  mobileNumber: Yup.string()
    .matches(/^\d{9,15}$/, "Mobile number must be 9 to 15 digits.")
    .required("Mobile number is required."),

  addressLine1: Yup.string()
    .trim()
    .min(1, "Address Line 1 should have at least 1 characters.")
    .max(200, "Address Line 1 should have at most 200 characters.")
    .required("Address Line 1 is required."),

  addressLine2: Yup.string()
    .trim()
    .max(200, "Address Line 2 should have at most 200 characters.")
    .nullable(),

  city: Yup.string()
    .trim()
    .min(1, "City should have at least 1 characters.")
    .max(100, "City should have at most 100 characters.")
    .required("City is required."),

  type: Yup.string()
    .uppercase()
    .oneOf(
      Object.values(CUSTOMER_TYPES),
      `Customer type must be one of ${Object.values(CUSTOMER_TYPES).join(
        ", "
      )}.`
    )
    .required("Customer type is required."),

  campaignId: Yup.string()
    .matches(
      /^[a-fA-F0-9]{24}$/,
      "Campaign ID must be a valid 24-character hex ObjectId."
    )
    .nullable()
    .when("type", {
      is: CUSTOMER_TYPES.EYE_CAMP,
      then: (schema) =>
        schema.required("Campaign ID is required for EYE_CAMP customer type."),
      otherwise: (schema) => schema.notRequired(),
    }),
});

const customerUpdateValidationSchema = Yup.object().shape({
  title: Yup.string()
    .uppercase()
    .oneOf(
      Object.values(CUSTOMER_TITLES),
      `Customer title must be one of ${Object.values(CUSTOMER_TITLES).join(
        ", "
      )}.`
    ),

  name: Yup.string()
    .trim()
    .min(1, "Customer name should have at least 1 characters.")
    .max(100, "Customer name should have at most 100 characters."),

  dob: Yup.date()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .max(new Date(), "Date of birth must be in the past.")
    .nullable()
    .notRequired()
    .typeError("Date of birth must be a valid date."),

  mobileNumber: Yup.string().matches(
    /^\d{9,15}$/,
    "Mobile number must be 9 to 15 digits."
  ),

  addressLine1: Yup.string()
    .trim()
    .min(1, "Address Line 1 should have at least 1 characters.")
    .max(200, "Address Line 1 should have at most 200 characters."),

  addressLine2: Yup.string()
    .trim()
    .max(200, "Address Line 2 should have at most 200 characters.")
    .nullable(),

  city: Yup.string()
    .trim()
    .min(1, "City should have at least 1 characters.")
    .max(100, "City should have at most 100 characters."),
});

export { customerCreateValidationSchema, customerUpdateValidationSchema };
